"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable import/no-cycle */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
const three_1 = require("three");
const types_1 = require("~/store/types");
const events_1 = require("~/utils/events");
const consts_1 = require("../consts");
const utils_1 = require("../utils");
const utils_3d_1 = require("../utils/utils.3d");
const Cad3d_scss_1 = __importDefault(require("../Cad3d.scss"));
const utils_2 = require("../../../utils/utils");
const AnchorDetection_3d_1 = __importStar(require("./AnchorDetection.3d"));
const models_1 = require("../models");
const SlicingTool_3d_1 = __importDefault(require("./SlicingTool.3d"));
const consts_2 = require("../consts/consts");
const tempQuaternion = new three_1.Quaternion();
const tempVector = new three_1.Vector3();
class ScalingTool {
    get EXTRUDE_STEP() {
        return this.viewer.isImperialMeasurementUsed ? consts_1.consts.DEFAULT_EXTRUDE_STEP : consts_1.consts.DEFAULT_EXTRUDE_STEP_SI;
    }
    constructor(viewer, mainTool) {
        this.object = null;
        this.maxScaleBeforeCollision = null;
        this.insertingObjectVertically = true;
        this.depthCompensated = false;
        this.panelCubes = [];
        this.isPanelSnapped = false;
        this.panelCubesSize = consts_1.consts.DEFAULT_PANEL_CUBE_SIZE;
        this.firstPanelAnchor = null;
        this.objectCollidedWithAngledExtrusion = null;
        this.viewer = viewer;
        this.mainTool = mainTool;
        this.intersectionPlane = this.createIntersectionPlane();
        this.viewer.getScene().add(this.intersectionPlane);
    }
    clearCollided() {
        this.collidedItemId = null;
        this.collidedItem = null;
    }
    scaleObjectToPointer(
    // eslint-disable-next-line default-param-last
    pointer = new three_1.Vector3(0, 0, 0), 
    // eslint-disable-next-line default-param-last
    verticalPointer = new three_1.Vector3(0, 0, 0), scale = null) {
        const { object } = this;
        if (!object || !object.isScalable || object.scalingAngle) {
            return;
        }
        // testing snap by plane
        const offsetX = pointer.x - this.mainTool.insertedObjectInitialPosition.x;
        const offsetY = pointer.y - this.mainTool.insertedObjectInitialPosition.y;
        const offsetZ = verticalPointer.z - this.viewer.getBackgroundPlane().position.z;
        let scalingValue;
        if (scale) {
            scalingValue = scale;
        }
        else {
            scalingValue = (0, utils_3d_1.areEqual)(object.directionNormal.z, 0)
                ? Math.max(Math.abs(offsetX), Math.abs(offsetY))
                : Math.abs(offsetZ);
        }
        const cameraPosition = this.viewer.getCamera().position;
        const zPosition = Math.abs(cameraPosition.z);
        const distance = cameraPosition.distanceTo(pointer);
        if (scalingValue >= 1 &&
            scalingValue <= consts_1.consts.DEFAULT_MAX_STOCK_LENGTH &&
            this.isScalingAllowed(offsetX, offsetY, offsetZ)) {
            let preToScale = scalingValue;
            if ((0, utils_3d_1.areNotEqual)(object.directionNormal.z, 0)) {
                preToScale += preToScale * 2 * Math.pow((zPosition / distance), 2);
            }
            let toScale = preToScale - (preToScale % this.EXTRUDE_STEP);
            if (toScale > object.partDetails.maxStockLength) {
                toScale = object.partDetails.maxStockLength;
            }
            if (this.maxScaleBeforeCollision - toScale > consts_1.consts.FLOAT_EPSILON || this.maxScaleBeforeCollision === null) {
                object.setScaleZ(toScale);
                this.mainTool.maxPositiveCoord = null;
                this.mainTool.maxNegativeCoord = null;
            }
            else {
                object.setScaleZ(this.maxScaleBeforeCollision - (this.maxScaleBeforeCollision % this.EXTRUDE_STEP));
                this.collidedItem = this.viewer.getObjectById(this.collidedItemId);
                const sign = this.object.directionNormal.x + this.object.directionNormal.y + this.object.directionNormal.z;
                if (sign > 0) {
                    this.mainTool.positiveObj = this.collidedItem;
                    this.mainTool.maxPositiveCoord = this.maxScaleBeforeCollision;
                }
                else {
                    this.mainTool.negativeObj = this.collidedItem;
                    this.mainTool.maxNegativeCoord = this.maxScaleBeforeCollision;
                }
            }
            const test = this.mainTool.snapHelper.checkPlaneSnap(this.object, this.object.position.clone().add(this.object.directionNormal.clone().multiplyScalar(this.object.getScale().z)), this.maxScaleBeforeCollision);
            if (test.result === true) {
                object.addScaleZ(test.dist * (object.directionNormal.x + object.directionNormal.y + object.directionNormal.z));
                if (object.getScale().z === this.maxScaleBeforeCollision) {
                    const sign = this.object.directionNormal.x + this.object.directionNormal.y + this.object.directionNormal.z;
                    if (sign > 0) {
                        this.mainTool.positiveObj = this.collidedItem;
                        this.mainTool.maxPositiveCoord = this.maxScaleBeforeCollision;
                    }
                    else {
                        this.mainTool.negativeObj = this.collidedItem;
                        this.mainTool.maxNegativeCoord = this.maxScaleBeforeCollision;
                    }
                }
            }
        }
        this.displayScalingValue(object);
        this.setScalingValuesForGrid();
    }
    scalePanelToPointer() {
        const panel = this.getObject();
        const { firstPanelAnchor } = this;
        if (!panel || !firstPanelAnchor) {
            return;
        }
        panel.setPosition(panel.positionOnDown);
        panel.setScale(panel.scaleOnDown, false);
        const anchorTestResult = this.viewer.calcHover(new Set([panel.uuid]));
        const secondPanelAnchor = this.calculatePanelAnchor(panel, anchorTestResult);
        this.scalePanelToAnchorAndUpdateAnchor(panel, secondPanelAnchor);
        this.updatePanelCubes(secondPanelAnchor);
        this.isPanelSnapped = secondPanelAnchor.snapped;
        this.mainTool.dimensioningTool.definePanelDimensions(panel);
    }
    scalePanelToAnchorAndUpdateAnchor(panel, anchor) {
        const panelSize = panel.getSize();
        const panelMatrix = new three_1.Matrix4().compose(panel.position, panel.quaternion, consts_2.unitVec);
        const anchorOriginInThePanelSpace = anchor.origin.clone().applyMatrix4(panelMatrix.clone().invert());
        for (let componentIndex = 0; componentIndex < 2; componentIndex += 1) {
            const initialPanelSize = panelSize.getComponent(componentIndex);
            const anchorOffset = anchor.xyOffsets.getComponent(componentIndex);
            const expectedAnchorPosition = anchorOriginInThePanelSpace.getComponent(componentIndex);
            let expectedPanelSize = Math.abs(expectedAnchorPosition) + anchorOffset;
            const anchorPositionSign = expectedAnchorPosition > 0 ? 1 : -1;
            if (anchorPositionSign > 0) {
                expectedPanelSize += initialPanelSize;
            }
            expectedPanelSize = Math.round(expectedPanelSize / this.EXTRUDE_STEP) * this.EXTRUDE_STEP;
            panel.setSizeComponent(componentIndex, expectedPanelSize);
            const actualPanelSize = panel.getSize().getComponent(componentIndex);
            let actualAnchorPosition = (actualPanelSize - anchorOffset) * anchorPositionSign;
            if ((0, utils_3d_1.areNotEqual)(expectedPanelSize, actualPanelSize)) {
                actualAnchorPosition = Math.min(Math.abs(expectedAnchorPosition), actualPanelSize) * anchorPositionSign;
                anchor.snapped = false;
            }
            if (anchorPositionSign > 0) {
                actualAnchorPosition -= initialPanelSize;
                panel.translateOnAxis(new three_1.Vector3().setComponent(componentIndex, 1), actualAnchorPosition + anchorOffset);
            }
            anchorOriginInThePanelSpace.setComponent(componentIndex, actualAnchorPosition);
        }
        anchor.origin = anchorOriginInThePanelSpace.applyMatrix4(panelMatrix);
    }
    addPanelCubes() {
        const panel = this.getObject();
        const { firstPanelAnchor } = this;
        if (!panel || !firstPanelAnchor) {
            return;
        }
        this.removePanelCubes();
        const position = firstPanelAnchor.origin;
        const rotation = panel.quaternion;
        // Add a cube for each corner of the panel.
        for (let panelCubeIdx = 0; panelCubeIdx < 4; panelCubeIdx += 1) {
            const panelCube = new models_1.PanelCube(this.panelCubesSize, panel.getSize().z, firstPanelAnchor.snappedToPerpendicular);
            panelCube.setPosition(position);
            panelCube.setRotationFromQuaternion(rotation);
            this.panelCubes.push(panelCube);
            this.viewer.getScene().add(panelCube);
        }
    }
    updatePanelCubes(secondPanelAnchor) {
        if (this.panelCubes.length === 0 || this.firstPanelAnchor === null) {
            return;
        }
        const firstAnchorPosition = this.firstPanelAnchor.origin;
        const firstAnchorNormal = this.firstPanelAnchor.normal;
        const secondAnchorPosition = secondPanelAnchor.origin;
        const updatedPositions = [firstAnchorPosition, secondAnchorPosition];
        if ((0, utils_3d_1.areNotEqual)(firstAnchorNormal.x, 0)) {
            updatedPositions.push(new three_1.Vector3(secondAnchorPosition.x, firstAnchorPosition.y, secondAnchorPosition.z), new three_1.Vector3(secondAnchorPosition.x, secondAnchorPosition.y, firstAnchorPosition.z));
        }
        else if ((0, utils_3d_1.areNotEqual)(firstAnchorNormal.y, 0)) {
            updatedPositions.push(new three_1.Vector3(firstAnchorPosition.x, secondAnchorPosition.y, secondAnchorPosition.z), new three_1.Vector3(secondAnchorPosition.x, secondAnchorPosition.y, firstAnchorPosition.z));
        }
        else if ((0, utils_3d_1.areNotEqual)(firstAnchorNormal.z, 0)) {
            updatedPositions.push(new three_1.Vector3(firstAnchorPosition.x, secondAnchorPosition.y, secondAnchorPosition.z), new three_1.Vector3(secondAnchorPosition.x, firstAnchorPosition.y, secondAnchorPosition.z));
        }
        this.panelCubes.forEach((cube, cubeIndex) => {
            cube.setPosition(updatedPositions[cubeIndex]);
            cube.highlight(secondPanelAnchor.snappedToPerpendicular);
        });
    }
    removePanelCubes() {
        if (this.panelCubes.length > 0) {
            this.viewer.getScene().remove(...this.panelCubes);
            this.panelCubes = [];
        }
    }
    updateIntersectionPlane(normal, coplanarPoint) {
        this.intersectionPlane.position.copy(coplanarPoint);
        this.intersectionPlane.setRotationFromQuaternion(tempQuaternion.setFromUnitVectors(consts_2.WORLD_AXES.Z, normal));
    }
    createIntersectionPlane() {
        const planeGeometry = new three_1.PlaneGeometry(10000, 10000);
        const planeMaterial = new three_1.MeshBasicMaterial({
            visible: false,
            side: three_1.DoubleSide,
        });
        return new three_1.Mesh(planeGeometry, planeMaterial);
    }
    calculatePanelAnchor(panel, anchorTestResult) {
        var _a;
        const panelAnchor = {
            origin: new three_1.Vector3(),
            normal: panel.directionNormal.clone(),
            snapped: false,
            snappedToPerpendicular: false,
            xyOffsets: new three_1.Vector2(),
        };
        const hoveredObject = this.viewer.getObjectById((_a = anchorTestResult.objectUUID) !== null && _a !== void 0 ? _a : '');
        const isExtrusion = hoveredObject && utils_1.Utils.isExtrusion(hoveredObject);
        const [snappingPointData] = AnchorDetection_3d_1.default.tryGetSnappingPointsData(anchorTestResult) || [];
        const [slotData] = AnchorDetection_3d_1.default.tryGetSlotsData(anchorTestResult) || [];
        if (isExtrusion && snappingPointData && this.isPanelCoplanarWithSnappingPoint(panel, snappingPointData)) {
            const extrusion = hoveredObject;
            this.buildPanelAnchorFromSnappingPoint(extrusion, panel, snappingPointData, panelAnchor);
        }
        else if (isExtrusion && slotData && this.isPanelCoplanarWithSlot(panel, slotData)) {
            const extrusion = hoveredObject;
            this.buildPanelAnchorFromSlot(extrusion, panel, slotData, anchorTestResult.intersectionPoint, panelAnchor);
        }
        else {
            const plane = this.intersectionPlane;
            const [planeIntersection] = this.viewer.getRaycaster().intersectObject(plane);
            if (planeIntersection) {
                panelAnchor.origin.copy(planeIntersection.point);
            }
        }
        return panelAnchor;
    }
    buildPanelAnchorFromSnappingPoint(extrusion, panel, snappingPoint, panelAnchor) {
        panelAnchor.origin.copy(snappingPoint.origin);
        panelAnchor.snapped = true;
        panelAnchor.xyOffsets = utils_1.Utils.calculateExtrusionSnappingPointSnappingAreaSize(extrusion, panel.xDirection, panel.yDirection).divideScalar(2);
    }
    buildPanelAnchorFromSlot(extrusion, panel, slot, intersectionPoint, panelAnchor) {
        const slotDirectionAxisIndex = utils_1.Utils.getWorldAxisIndex(slot.direction);
        let anchorPositionBySlotDirection = intersectionPoint.getComponent(slotDirectionAxisIndex);
        const signedDistanceToPerpendicular = this.calculateDistanceToTheClosestPerpendicularSlot(extrusion, slot, intersectionPoint);
        if (Math.abs(signedDistanceToPerpendicular) < consts_1.consts.CLOSEST_PERPENDICULAR_SLOT_THRESHOLD) {
            panelAnchor.snappedToPerpendicular = true;
            anchorPositionBySlotDirection -= slot.direction
                .clone()
                .multiplyScalar(signedDistanceToPerpendicular)
                .getComponent(slotDirectionAxisIndex);
        }
        else {
            panelAnchor.snappedToPerpendicular = false;
            anchorPositionBySlotDirection = Math.round(anchorPositionBySlotDirection / this.EXTRUDE_STEP) * this.EXTRUDE_STEP;
        }
        panelAnchor.origin.copy(slot.surfacePoint).setComponent(slotDirectionAxisIndex, anchorPositionBySlotDirection);
        panelAnchor.snapped = true;
        panelAnchor.xyOffsets = utils_1.Utils.calculateExtrusionSlotSnappingAreaSize(extrusion, slot.normal, panel.zDirection.clone().cross(extrusion.zDirection)).divideScalar(2);
    }
    isPanelCoplanarWithSnappingPoint(panel, snappingPoint) {
        return this.isPanelCoplanarWithAnchor(panel, {
            origin: snappingPoint.origin,
            normal: snappingPoint.normal,
        });
    }
    isPanelCoplanarWithSlot(panel, slot) {
        return this.isPanelCoplanarWithAnchor(panel, {
            origin: slot.surfacePoint,
            normal: slot.normal,
        });
    }
    isPanelCoplanarWithAnchor(panel, anchorData) {
        const plane = new three_1.Plane();
        plane.setFromNormalAndCoplanarPoint(panel.directionNormal, panel.position);
        return (utils_1.Utils.areVectorsEqual(plane.normal, anchorData.normal) &&
            utils_1.Utils.areEqual(plane.distanceToPoint(anchorData.origin), 0, 1e-3));
    }
    calculateDistanceToTheClosestPerpendicularSlot(hoveredExtrusion, hoveredSlot, hoveredSlotPoint) {
        const plane = new three_1.Plane();
        plane.setFromNormalAndCoplanarPoint(hoveredSlot.normal, hoveredSlot.surfacePoint);
        return hoveredExtrusion.connectedItems
            .reduce((coplanarSlots, connectedItem) => {
            var _a;
            if (connectedItem.itemType === types_1.ITEM_TYPE.EXTRUSION && connectedItem.connectedSide === 'end') {
                const extrusion = this.viewer.getObjectById(connectedItem.uuid);
                const slots = (_a = extrusion.getSlots()) !== null && _a !== void 0 ? _a : [];
                coplanarSlots.push(...slots.filter((slot) => utils_1.Utils.areVectorsEqual(slot.normal, hoveredSlot.normal) &&
                    utils_1.Utils.areEqual(plane.distanceToPoint(slot.surfacePoint), 0)));
            }
            return coplanarSlots;
        }, [])
            .reduce((minDistance, coplanarSlot) => {
            plane.setFromNormalAndCoplanarPoint(hoveredSlot.direction, coplanarSlot.surfacePoint);
            const distance = plane.distanceToPoint(hoveredSlotPoint);
            return Math.abs(distance) < Math.abs(minDistance) ? distance : minDistance;
        }, Infinity);
    }
    displayScalingValue(object) {
        if (!object) {
            return;
        }
        const { object: objectData } = this;
        if (object.type === 'Panel') {
            return;
        }
        const labelPosition = utils_1.Utils.objectPositionToScreenPosition(object, this.viewer.getCamera(), true);
        const value = this.viewer.isImperialMeasurementUsed
            ? (0, utils_2.getLabelInInch)(object === null || object === void 0 ? void 0 : object.getScale().z)
            : (0, utils_2.getLabelInMM)(object === null || object === void 0 ? void 0 : object.getScale().z);
        const shouldShowScalingValue = this.mainTool.scalingInProgress ||
            (this.mainTool.transformationInProgress &&
                this.mainTool.selectionTool.selectedObjects.length === 1 &&
                this.mainTool.transformControlsInitial.mode === consts_2.TRANSFORM_MODE.SCALE);
        let labelDiv = null;
        if (object.type === 'Extrusion') {
            labelDiv = document.getElementById(Cad3d_scss_1.default.lengthEditableLabel);
        }
        else {
            labelDiv = document.getElementById(Cad3d_scss_1.default.lengthLabel);
            labelDiv.textContent = value;
        }
        labelDiv.style.left = `${labelPosition.x}px`;
        labelDiv.style.top = `${labelPosition.y - 30}px`;
        labelDiv.style.display = shouldShowScalingValue ? 'block' : 'none';
        if (object.type === 'Extrusion') {
            const inputEl = labelDiv.getElementsByTagName('input')[0];
            inputEl.dataset.uuid = object.uuid;
            inputEl.dataset.maxStockLength = objectData
                ? objectData.partDetails.maxStockLength.toString()
                : consts_1.consts.DEFAULT_MAX_STOCK_LENGTH.toString();
            inputEl.readOnly = false;
            (0, events_1.dispatchSetValueModal)(value);
        }
    }
    // eslint-disable-next-line class-methods-use-this
    getThetaStart(angle, neighborDirection, objectNeighborDirection, angleBetween) {
        let thetaStart;
        const angleInRads = (angle * Math.PI) / 180;
        if ((0, utils_3d_1.areNotEqual)(neighborDirection.x, 0)) {
            if (angleBetween < Math.PI / 2) {
                thetaStart = -Math.PI / 2;
            }
            else {
                thetaStart = Math.PI / 2;
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(neighborDirection.y, 0)) {
            if (angleBetween < Math.PI / 2) {
                thetaStart = 0;
            }
            else {
                thetaStart = Math.PI;
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(neighborDirection.z, 0)) {
            if ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0)) {
                if (angleBetween < Math.PI / 2) {
                    thetaStart = 0;
                }
                else {
                    thetaStart = Math.PI;
                }
            }
            else if ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.y, 0)) {
                if (angleBetween < Math.PI / 2) {
                    thetaStart = -Math.PI / 2 + angleInRads;
                }
                else {
                    thetaStart = Math.PI / 2 - angleInRads;
                }
            }
        }
        return thetaStart;
    }
    // eslint-disable-next-line class-methods-use-this
    getThetaLength(angle, neighborDirection, angleBetween) {
        let sign = 1;
        if ((0, utils_3d_1.areNotEqual)(neighborDirection.x, 0)) {
            if (neighborDirection.x > 0) {
                sign = angleBetween < Math.PI / 2 ? 1 : -1;
            }
            else if (neighborDirection.x < 0) {
                sign = angleBetween < Math.PI / 2 ? -1 : 1;
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(neighborDirection.y, 0)) {
            if (neighborDirection.y > 0) {
                sign = angleBetween < Math.PI / 2 ? 1 : -1;
            }
            else if (neighborDirection.y < 0) {
                sign = angleBetween < Math.PI / 2 ? -1 : 1;
            }
        }
        else if ((0, utils_3d_1.areNotEqual)(neighborDirection.z, 0)) {
            if (neighborDirection.z > 0) {
                sign = angleBetween < Math.PI / 2 ? 1 : -1;
            }
            else if (neighborDirection.z < 0) {
                sign = angleBetween < Math.PI / 2 ? -1 : 1;
            }
        }
        const thetaLength = (sign * (angle * Math.PI)) / 180;
        return thetaLength;
    }
    displayAngleValue(object, angle, position, objectNeighborNormal, objectNeighborDirection) {
        if (!object) {
            return;
        }
        const { angleArc } = this.viewer;
        angleArc.visible = true;
        const positionInit = new three_1.Vector3();
        positionInit.copy(this.objectPosition);
        angleArc.position.copy(position);
        const { rotation } = this.viewer.slidePlane;
        angleArc.setRotationFromEuler(rotation);
        const angleBetween = object.directionNormal.angleTo(objectNeighborDirection);
        const positionDelta = this.distance(positionInit, position);
        const radius = 4 - positionDelta;
        angleArc.geometry.dispose();
        angleArc.geometry = new three_1.CircleGeometry(radius, 32, this.getThetaStart(angle, objectNeighborNormal, objectNeighborDirection, angleBetween), this.getThetaLength(angle, objectNeighborNormal, angleBetween));
        if (objectNeighborNormal.z > 0) {
            angleArc.visible = false;
        }
        else {
            angleArc.visible = true;
        }
        const labelMoveDirection = new three_1.Vector3();
        labelMoveDirection.addVectors(object.directionNormal, angleBetween < Math.PI / 2 ? objectNeighborDirection.clone() : objectNeighborDirection.clone().negate());
        position.add(labelMoveDirection.normalize().multiplyScalar(radius));
        const labelPosition = utils_1.Utils.positionToScreenPosition(position, this.viewer.getCamera());
        const labelDiv = document.getElementById(Cad3d_scss_1.default.angleLabel);
        if (labelDiv) {
            labelDiv.textContent = `${utils_1.Utils.roundTo2(angle).toFixed()}°`;
            labelDiv.style.left = `${labelPosition.x}px`;
            labelDiv.style.top = `${labelPosition.y - 30}px`;
            labelDiv.style.display = this.mainTool.scalingInProgress ? 'block' : 'none';
        }
    }
    setScalingValuesForGrid() {
        const scalingOffsets = this.getMaxScalingOffsets();
        this.viewer.getGrid().setBuildPlaneSize(scalingOffsets.maximumOffset);
        this.viewer.getGrid().setBuildPlaneVerticalPosition(scalingOffsets.positionZ);
    }
    getMaxScalingOffsets() {
        const boundingBox = utils_1.Utils.getSceneBoundingBox(this.viewer);
        const maximumOffset = Math.max(Math.abs(boundingBox.min.x), Math.abs(boundingBox.min.y), Math.abs(boundingBox.max.x), Math.abs(boundingBox.max.y));
        return { maximumOffset, positionZ: boundingBox.max.z };
    }
    setObject(newObject) {
        this.object = newObject;
        this.slicingTool = new SlicingTool_3d_1.default(this.object);
        this.calculateBBox(newObject);
        this.depthCompensated = false;
        this.checkedDir = '';
        this.maxScaleBeforeCollision = null;
        const directionNormal = (0, utils_3d_1.roundVectorTo3)(newObject.directionNormal.clone());
        // temporary workaround, will be replaced soon
        if (directionNormal.x < 0) {
            this.checkCollisionForDir('-X');
        }
        else if (directionNormal.y < 0) {
            this.checkCollisionForDir('-Y');
        }
        else if (directionNormal.z < 0) {
            this.checkCollisionForDir('-Z');
        }
        else if (directionNormal.x > 0) {
            this.checkCollisionForDir('X');
        }
        else if (directionNormal.y > 0) {
            this.checkCollisionForDir('Y');
        }
        else if (directionNormal.z > 0) {
            this.checkCollisionForDir('-Z');
        }
    }
    getObject() {
        return this.object;
    }
    clearObject() {
        this.object = null;
    }
    calculateBBox(newObject) {
        const objectBbox = utils_1.Utils.getAABBox(newObject);
        this.objectSizeMin = objectBbox.min;
        this.objectSizeMax = objectBbox.max;
    }
    setObjectRotationToDefault() {
        var _a;
        (_a = this.object) === null || _a === void 0 ? void 0 : _a.setRotation(utils_1.Utils.identityQuaternion);
    }
    setObjectTranslationToDefault() {
        var _a;
        (_a = this.object) === null || _a === void 0 ? void 0 : _a.setPosition(this.mainTool.insertedObjectInitialPosition);
    }
    setObjectScaleToDefault() {
        var _a;
        (_a = this.object) === null || _a === void 0 ? void 0 : _a.setScale(new three_1.Vector3(1, 1, 1));
    }
    // Methods for setting the object position and rotation according to selected scaling direction
    detectAngledScalingDirection(pointer, objectNeighborDirection, objectNeighborNormal, neighborID) {
        var _a;
        const { object } = this;
        if (!this.initialSize) {
            this.initialSize = utils_1.Utils.getAABBoxSize(object);
        }
        const scalingValue = object.position.distanceTo(pointer);
        let toScale = scalingValue - (scalingValue % this.EXTRUDE_STEP);
        const dir = new three_1.Vector3();
        dir.subVectors(pointer, object.position).normalize();
        let angle = dir.angleTo(objectNeighborNormal);
        let angleDegrees = (angle * 180) / Math.PI;
        angleDegrees = Math.round(angleDegrees);
        angle = (angleDegrees / 180) * Math.PI;
        if (angle >= consts_1.consts.ANGLED_EXTRUSION_LIMIT_LOWER) {
            angle = consts_1.consts.ANGLED_EXTRUSION_LIMIT_LOWER;
        }
        else if (angle <= consts_1.consts.ANGLED_EXTRUSION_LIMIT_UPPER) {
            angle = consts_1.consts.ANGLED_EXTRUSION_LIMIT_UPPER;
        }
        // setting the rotation axis
        const rotationAxis = (0, utils_3d_1.invertVector)(objectNeighborNormal.clone().add(objectNeighborDirection));
        // setting the angle direction
        if (!this.objectPosition) {
            this.objectPosition = object.position.clone();
        }
        let adjustment = 1;
        let longSide;
        let shortSide;
        if (objectNeighborNormal.x > 0) {
            if (((0, utils_3d_1.areNotEqual)(objectNeighborDirection.y, 0) && pointer.y < object.position.y) ||
                ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) && pointer.z > object.position.z)) {
                adjustment = -1;
            }
            if (angle <= Math.PI / 3) {
                longSide = (0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) ? this.initialSize.z : this.initialSize.y;
                shortSide = (longSide / 2) * Math.sin(angle);
                object.setPositionX(this.objectPosition.x - shortSide);
            }
        }
        else if (objectNeighborNormal.x < 0) {
            if (((0, utils_3d_1.areNotEqual)(objectNeighborDirection.y, 0) && pointer.y > object.position.y) ||
                ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) && pointer.z < object.position.z)) {
                adjustment = -1;
            }
            if (angle <= Math.PI / 3) {
                longSide = (0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) ? this.initialSize.z : this.initialSize.y;
                shortSide = (longSide / 2) * Math.sin(angle);
                object.setPositionX(this.objectPosition.x + shortSide);
            }
        }
        else if (objectNeighborNormal.y < 0) {
            if (((0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0) && pointer.x < object.position.x) ||
                ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) && pointer.z > object.position.z)) {
                adjustment = -1;
            }
            if (angle <= Math.PI / 3) {
                longSide = (0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) ? this.initialSize.z : this.initialSize.x;
                shortSide = (longSide / 2) * Math.sin(angle);
                object.setPositionY(this.objectPosition.y + shortSide);
            }
        }
        else if (objectNeighborNormal.y > 0) {
            if (((0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0) && pointer.x > object.position.x) ||
                ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) && pointer.z < object.position.z)) {
                adjustment = -1;
            }
            if (angle <= Math.PI / 3) {
                longSide = (0, utils_3d_1.areNotEqual)(objectNeighborDirection.z, 0) ? this.initialSize.z : this.initialSize.x;
                shortSide = (longSide / 2) * Math.sin(angle);
                object.setPositionY(this.objectPosition.y - shortSide);
            }
        }
        else if (objectNeighborNormal.z < 0) {
            if (((0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0) && pointer.x > object.position.x) ||
                ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.y, 0) && pointer.y < object.position.y)) {
                adjustment = -1;
            }
            if (angle <= Math.PI / 3) {
                longSide = (0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0) ? this.initialSize.x : this.initialSize.y;
                shortSide = (longSide / 2) * Math.sin(angle);
                object.setPositionZ(this.objectPosition.z + shortSide);
            }
        }
        else if (objectNeighborNormal.z > 0) {
            if (((0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0) && pointer.x < object.position.x) ||
                ((0, utils_3d_1.areNotEqual)(objectNeighborDirection.y, 0) && pointer.y > object.position.y)) {
                adjustment = -1;
            }
            if (angle <= Math.PI / 3) {
                longSide = (0, utils_3d_1.areNotEqual)(objectNeighborDirection.x, 0) ? this.initialSize.x : this.initialSize.y;
                shortSide = (longSide / 2) * Math.sin(angle);
                object.setPositionZ(this.objectPosition.z - shortSide);
            }
        }
        const quat = new three_1.Quaternion().setFromEuler(this.mainTool.snappingTool.snappedRotation);
        const quat1 = new three_1.Quaternion().setFromAxisAngle(rotationAxis, adjustment * angle);
        const testDirection = new three_1.Vector3(0, 0, -1).applyQuaternion(quat.premultiply(quat1)).normalize();
        const test = this.viewer.collisionProcessor.testAngledCollision(this.object, testDirection, new Set([neighborID]));
        // calculate adjustment to detect collision only when the tip of extrusion intersects
        let adj = 0;
        const collidedObjDir = this.viewer.collisionProcessor.getObjNormal(test.coProIndex);
        // adjustment calculation depends on whether angled extrusion is between parallel or perpendicular extrusions
        if ((0, utils_3d_1.areVectorsCollinear)(collidedObjDir, objectNeighborDirection)) {
            adj = this.mainTool.halfSideAngled * Math.tan(angle);
        }
        else {
            adj = this.mainTool.halfSideAngled / Math.tan(angle);
        }
        if (test.result === true && test.distance - adj < toScale) {
            // if there is a collision, increase extrusion length to "snap" it to the surface
            // eslint-disable-next-line no-shadow
            const collidedObject = utils_1.Utils.getObjectByUUID(this.viewer.getScene(), (_a = test.uuid) !== null && _a !== void 0 ? _a : '');
            if (collidedObject &&
                (collidedObject === null || collidedObject === void 0 ? void 0 : collidedObject.type) === 'Extrusion' &&
                this.object.type === 'Extrusion' &&
                !utils_1.Utils.areSeriesCompatible(collidedObject, this.object)) {
                this.objectCollidedWithAngledExtrusion = collidedObject;
                this.viewer.getDesignProMain().highlightingTool.highlightObject(this.object);
                this.viewer.getDesignProMain().highlightingTool.highlightObject(collidedObject);
            }
            toScale = adj + test.distance;
        }
        else {
            this.objectCollidedWithAngledExtrusion = null;
            this.viewer.getDesignProMain().highlightingTool.clearConnectionHighlight();
        }
        object.setScaleZ(toScale);
        this.object.setRotationFromEuler(this.mainTool.snappingTool.snappedRotation);
        this.object.rotateOnWorldAxis(rotationAxis, adjustment * angle);
        let dist = this.mainTool.halfSideAngled * Math.tan(angle);
        const cornerPos = this.object.position.clone().add(this.object.directionNormal.clone().multiplyScalar(dist));
        dist = this.mainTool.halfSideAngled / Math.cos(angle);
        let sign = 1;
        if (this.object.directionNormal.clone().dot(objectNeighborDirection) < 0) {
            sign = -1;
        }
        cornerPos.add(objectNeighborDirection.clone().multiplyScalar(dist * sign));
        this.object.scalingAngle = 90 - (angle * 180) / Math.PI;
        this.displayAngleValue(object, 90 - (angle * 180) / Math.PI, cornerPos, objectNeighborNormal, objectNeighborDirection);
        const newDirection = new three_1.Vector3(0, 0, -1).applyQuaternion(this.object.quaternion).normalize();
        this.object.directionNormal.copy(newDirection);
        this.setScalingValuesForGrid();
        this.clipNormal = objectNeighborNormal;
        this.position = this.objectPosition;
        this.sliceGeometry(objectNeighborNormal, this.objectPosition, test.normal, test.point);
        this.displayScalingValue(object);
    }
    triggerSlice() {
        this.sliceGeometry(this.clipNormal, this.position);
    }
    sliceGeometry(normal, position, normal2, position2) {
        var _a;
        const planes = [new three_1.Plane().setFromNormalAndCoplanarPoint(normal, position)];
        if (position2 && normal2) {
            planes.push(new three_1.Plane().setFromNormalAndCoplanarPoint(normal2, position2));
        }
        (_a = this.slicingTool) === null || _a === void 0 ? void 0 : _a.cutWithPlanes(planes);
    }
    detectFutureScalingDirection(cameraToPointerLine) {
        var _a;
        const translatedXAxis = new three_1.Line3();
        const translatedYAxis = new three_1.Line3();
        const translatedZAxis = new three_1.Line3();
        translatedXAxis.start.copy(this.mainTool.insertedObjectInitialPosition);
        translatedYAxis.start.copy(this.mainTool.insertedObjectInitialPosition);
        translatedZAxis.start.copy(this.mainTool.insertedObjectInitialPosition);
        translatedXAxis.end.addVectors(translatedXAxis.start, consts_1.consts.DIRECTIONS_LIST.X);
        translatedYAxis.end.addVectors(translatedYAxis.start, consts_1.consts.DIRECTIONS_LIST.Y);
        translatedZAxis.end.addVectors(translatedZAxis.start, consts_1.consts.DIRECTIONS_LIST.Z);
        const distanceX = utils_1.Utils.minDistBetweenTwoLines(cameraToPointerLine, translatedXAxis);
        const distanceY = utils_1.Utils.minDistBetweenTwoLines(cameraToPointerLine, translatedYAxis);
        const distanceZ = utils_1.Utils.minDistBetweenTwoLines(cameraToPointerLine, translatedZAxis);
        let axis;
        if (distanceX < distanceY && distanceX < distanceZ) {
            axis = 'x';
        }
        else if (distanceY < distanceZ) {
            axis = 'y';
        }
        else {
            axis = 'z';
        }
        const planeNormal = cameraToPointerLine.delta(new three_1.Vector3());
        const planeAlongSelectedAxis = new three_1.Plane().setFromNormalAndCoplanarPoint(planeNormal, this.mainTool.insertedObjectInitialPosition);
        const intersection = new three_1.Vector3();
        planeAlongSelectedAxis.intersectLine(cameraToPointerLine, intersection);
        const direction = intersection[axis] < this.mainTool.insertedObjectInitialPosition[axis] ? 'negative' : 'positive';
        const offset = intersection.sub(this.mainTool.insertedObjectInitialPosition)[axis];
        if (((_a = this.mainTool.objectNeighbor) === null || _a === void 0 ? void 0 : _a.face) &&
            this.tryingToScaleIntoNeighbor(this.mainTool.objectNeighbor.face.normal[axis], offset)) {
            return;
        }
        this.mainTool.scalingDirection = consts_1.consts.AXES[direction + axis.toUpperCase()];
        this.depthCompensated = false;
        this.setObjectToScalingDirection();
    }
    tryingToScaleIntoNeighbor(objectNeighborNormalCoordinate, offset) {
        var _a, _b, _c;
        if ((_a = this.mainTool.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object) {
            return undefined;
        }
        const snappedToBuildPlane = ((_c = (_b = this.mainTool.objectNeighbor) === null || _b === void 0 ? void 0 : _b.object) === null || _c === void 0 ? void 0 : _c.geometry.type) === 'PlaneGeometry';
        if (snappedToBuildPlane) {
            return false;
        }
        return (objectNeighborNormalCoordinate < 0 && offset > 0) || (objectNeighborNormalCoordinate > 0 && offset < 0);
    }
    setObjectToScalingDirection() {
        var _a, _b;
        this.mainTool.dragControls.setPositionShift(null);
        const snappedToBuildPlane = ((_b = (_a = this.mainTool.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object) === null || _b === void 0 ? void 0 : _b.geometry.type) === 'PlaneGeometry';
        const { anchorTestResult } = this.mainTool;
        const anchorNormal = anchorTestResult && [AnchorDetection_3d_1.AnchorResultType.slot, AnchorDetection_3d_1.AnchorResultType.snapPt].includes(anchorTestResult.resultType)
            ? anchorTestResult.resultData[0].normal
            : null;
        let objectNeighborFaceNormal;
        if (!snappedToBuildPlane && anchorNormal) {
            objectNeighborFaceNormal = anchorNormal;
        }
        else if (this.mainTool.snappingTool.neighborObject) {
            objectNeighborFaceNormal = consts_1.consts.DIRECTIONS_LIST[consts_1.consts.AXES.positiveZ];
        }
        else {
            objectNeighborFaceNormal = consts_1.consts.DIRECTIONS_LIST[consts_1.consts.AXES.negativeZ];
        }
        if (!objectNeighborFaceNormal) {
            return;
        }
        const snappedToUpperFace = (0, utils_3d_1.areNotEqual)(objectNeighborFaceNormal.z, 0, consts_1.consts.THREE_FLOAT_EPSILON);
        const scalingDirectionVector = utils_1.Utils.letter2Vec(this.mainTool.scalingDirection);
        this.setObjectTranslationToDefault();
        this.object.setScaleZ(consts_1.consts.DEFAULT_SCALE_FOR_EXTRUSIONS);
        this.object.setRotation(this.mainTool.snappingTool.snappedRotation
            ? tempQuaternion.setFromEuler(this.mainTool.snappingTool.snappedRotation)
            : utils_1.Utils.identityQuaternion);
        this.object.rotate(tempQuaternion.setFromUnitVectors(this.object.directionNormal, scalingDirectionVector));
        switch (this.mainTool.scalingDirection) {
            case consts_1.consts.AXES.negativeX:
            case consts_1.consts.AXES.positiveX:
                this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveX;
                this.object.notFlatWise = true;
                this.insertingObjectVertically = false;
                break;
            case consts_1.consts.AXES.positiveY:
            case consts_1.consts.AXES.negativeY:
                this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveY;
                this.object.notFlatWise = false;
                this.insertingObjectVertically = false;
                break;
            case consts_1.consts.AXES.negativeZ:
            case consts_1.consts.AXES.positiveZ:
                this.object.customScalingAxis = consts_1.consts.POSITIVE_AXES.positiveZ;
                this.object.notFlatWise = false;
                this.insertingObjectVertically = true;
                break;
            default:
                break;
        }
        const postRotateBBoxSize = utils_1.Utils.getAABBoxSize(this.object);
        if (utils_1.Utils.areVectorsEqual(scalingDirectionVector, tempVector.copy(objectNeighborFaceNormal).negate(), consts_1.consts.THREE_FLOAT_EPSILON)) {
            this.object.translate(postRotateBBoxSize.multiply(objectNeighborFaceNormal));
        }
        else if (utils_1.Utils.areVectorsNotEqual(scalingDirectionVector, objectNeighborFaceNormal, consts_1.consts.THREE_FLOAT_EPSILON)) {
            this.object.translate(postRotateBBoxSize.multiply(objectNeighborFaceNormal).multiplyScalar(0.5));
        }
        this.object.setObjectDirectionNormal(scalingDirectionVector);
        if (snappedToUpperFace) {
            this.moveToAlignEndFacesVertically();
        }
        else if (!utils_1.Utils.areVectorsCollinear(scalingDirectionVector, objectNeighborFaceNormal)) {
            this.moveToAlignSideFaces(scalingDirectionVector, objectNeighborFaceNormal);
        }
        this.checkCollisionForDir(this.mainTool.scalingDirection);
    }
    moveToAlignEndFacesVertically() {
        switch (this.mainTool.scalingDirection) {
            case consts_1.consts.AXES.negativeX:
                this.object.translateZ((this.objectSizeMax.x - this.objectSizeMin.x) * 0.5);
                break;
            case consts_1.consts.AXES.positiveX:
                this.object.translateZ((this.objectSizeMax.x - this.objectSizeMin.x) * 0.5);
                break;
            case consts_1.consts.AXES.positiveY:
                this.object.translateZ((this.objectSizeMax.y - this.objectSizeMin.y) * 0.5);
                break;
            case consts_1.consts.AXES.negativeY:
                this.object.translateZ((this.objectSizeMax.y - this.objectSizeMin.y) * 0.5);
                break;
            case consts_1.consts.AXES.negativeZ:
                break;
            case consts_1.consts.AXES.positiveZ:
                break;
            default:
                break;
        }
    }
    moveToAlignOnXSide(objectBBox, neighborBBox, objectsParallel, translationDirection) {
        const distance = Math.abs(Math.min(neighborBBox.max.x - objectBBox.min.x, objectBBox.max.x - neighborBBox.min.x));
        switch (this.mainTool.scalingDirection) {
            case consts_1.consts.AXES.positiveY:
                if (!objectsParallel) {
                    this.object.setPositionY(neighborBBox.min.y);
                }
                break;
            case consts_1.consts.AXES.negativeY:
                if (!objectsParallel) {
                    this.object.setPositionY(neighborBBox.max.y);
                }
                break;
            case consts_1.consts.AXES.positiveZ:
                if (!objectsParallel) {
                    this.object.setPositionZ(neighborBBox.min.z);
                }
                break;
            case consts_1.consts.AXES.negativeZ:
                if (!objectsParallel) {
                    this.object.setPositionZ(neighborBBox.max.z);
                }
                break;
            default:
                break;
        }
        if (!this.depthCompensated) {
            this.object.setPositionX(this.object.position.x + distance * translationDirection.x);
            this.depthCompensated = true;
        }
    }
    moveToAlignOnYSide(objectBBox, neighborBBox, objectsParallel, translationDirection) {
        const distance = Math.abs(Math.min(neighborBBox.max.y - objectBBox.min.y, objectBBox.max.y - neighborBBox.min.y));
        switch (this.mainTool.scalingDirection) {
            case consts_1.consts.AXES.positiveX:
                if (!objectsParallel) {
                    this.object.setPositionX(neighborBBox.min.x);
                }
                break;
            case consts_1.consts.AXES.negativeX:
                if (!objectsParallel) {
                    this.object.setPositionX(neighborBBox.max.x);
                }
                break;
            case consts_1.consts.AXES.positiveZ:
                if (!objectsParallel) {
                    this.object.setPositionZ(neighborBBox.min.z);
                }
                break;
            case consts_1.consts.AXES.negativeZ:
                if (!objectsParallel) {
                    this.object.setPositionZ(neighborBBox.max.z);
                }
                break;
            default:
                break;
        }
        if (!this.depthCompensated) {
            this.object.translateOnAxis(translationDirection, distance);
            this.depthCompensated = true;
        }
    }
    moveToAlignSideFaces(scalingDirectionVector, objectNeighborFaceNormal) {
        var _a;
        const neighborObjectId = (_a = this.mainTool.objectNeighbor) === null || _a === void 0 ? void 0 : _a.object.name.split('|')[1];
        if (!neighborObjectId) {
            return;
        }
        const neighborObject = this.viewer.getObjectById(neighborObjectId);
        const objectBBox = utils_1.Utils.getAABBox(this.object);
        const neighborBBox = utils_1.Utils.getAABBox(neighborObject);
        const objectsParallel = utils_1.Utils.areVectorsCollinear(this.object.directionNormal, neighborObject.directionNormal);
        const snappedToEnd = utils_1.Utils.areVectorsCollinear(this.object.directionNormal, objectNeighborFaceNormal);
        if (!this.object.hasSnappingMetadata || !neighborObject.hasSnappingMetadata) {
            if ((0, utils_3d_1.areNotEqual)(objectNeighborFaceNormal.x, 0)) {
                this.moveToAlignOnXSide(objectBBox, neighborBBox, objectsParallel, objectNeighborFaceNormal);
            }
            if ((0, utils_3d_1.areNotEqual)(objectNeighborFaceNormal.y, 0)) {
                this.moveToAlignOnYSide(objectBBox, neighborBBox, objectsParallel, objectNeighborFaceNormal);
            }
            if (objectsParallel && !snappedToEnd) {
                this.object.translate(tempVector
                    .subVectors(this.objectSizeMax, this.objectSizeMin)
                    .multiply(scalingDirectionVector)
                    .multiplyScalar(-0.5));
            }
        }
        else if (utils_1.Utils.areVectorsNotEqual(objectNeighborFaceNormal, this.object.directionNormal)) {
            this.object.translate(tempVector
                .subVectors(this.objectSizeMax, this.objectSizeMin)
                .multiply(scalingDirectionVector)
                .multiplyScalar(-0.5));
        }
    }
    isScalingAllowed(offsetX, offsetY, offsetZ) {
        let scalingAllowed = true;
        switch (this.mainTool.scalingDirection) {
            case consts_1.consts.AXES.negativeX:
                if (offsetX > 0) {
                    scalingAllowed = false;
                }
                break;
            case consts_1.consts.AXES.positiveX:
                if (offsetX < 0) {
                    scalingAllowed = false;
                }
                break;
            case consts_1.consts.AXES.negativeY:
                if (offsetY > 0) {
                    scalingAllowed = false;
                }
                break;
            case consts_1.consts.AXES.positiveY:
                if (offsetY < 0) {
                    scalingAllowed = false;
                }
                break;
            case consts_1.consts.AXES.negativeZ:
                if (offsetZ > 0) {
                    scalingAllowed = false;
                }
                break;
            case consts_1.consts.AXES.positiveZ:
                if (offsetZ < 0) {
                    scalingAllowed = false;
                }
                break;
            default:
                break;
        }
        return scalingAllowed;
    }
    checkCollisionForDir(dir) {
        if (this.checkedDir !== '' && this.checkedDir === dir) {
            return;
        }
        this.checkedDir = dir;
        const direction = utils_1.Utils.letter2Vec(dir);
        if (direction === null) {
            return;
        }
        const test = this.viewer.collisionProcessor.getClosestCollision(this.object, direction);
        if (test.result === true) {
            this.collidedItemId = this.viewer.collisionProcessor.getObjUUID(test.index);
            this.maxScaleBeforeCollision = test.index.distanceToCollision;
        }
        else {
            this.maxScaleBeforeCollision = null;
            this.viewer.getScene().remove(this.viewer.getScene().getObjectByName(`Collision`));
        }
    }
    // eslint-disable-next-line class-methods-use-this
    distance(a, b) {
        return Math.sqrt(Math.pow((b.x - a.x), 2) + Math.pow((b.y - a.y), 2) + Math.pow((b.z - a.z), 2));
    }
}
exports.default = ScalingTool;
